import React from "react";

const EyeClosed = () => (
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity=".5" fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M2.6 11.3l.7-.7C2.6 9.8 1.9 9 1.5 8c1-2.5 3.8-4.5 6.5-4.5.7 0 1.4.1 2 .4l.8-.8C9.9 2.7 9 2.5 8 2.5 4.7 2.6 1.7 4.7.5 7.8v.3c.5 1.2 1.2 2.3 2.1 3.2zm10-7.2c1.3.9 2.3 2.2 2.9 3.7v.4c-1.2 3.1-4.2 5.2-7.5 5.3-1.3-.1-2.6-.4-3.7-1.1L1.7 15l-.7-.7L14.3 1l.7.7-2.4 2.4zm-4.8 2c-.9 0-1.7.8-1.8 1.8l-.9.9c-.1-.5-.1-1.1 0-1.6.4-1.6 2.1-2.5 3.6-2l-.9.9zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7c.2.3.3.6.3 1zm-5 3.7c.9.5 2 .8 3 .8 2.6 0 5.4-2 6.5-4.5-.6-1.3-1.5-2.4-2.6-3.2l-1.4 1.4c.7 1 .7 2.4 0 3.4-1 1.4-2.8 1.7-4.2.8L5 11.7z" />
  </svg>
);

export default EyeClosed;
